export default "__VITE_ASSET__CkhPveTY__"